import { Capacitor } from '@capacitor/core'
import { User } from '@vae/server/dist/client'
import { useEffect } from 'react'
import useUser from '../../contexts/hooks/useUser'
import {
	initializeFirebaseWebAnalytics,
	setAnalyticsEnabled,
	setUserId,
	setUserProperty,
} from '../utils/firebaseUtils'

const useAnalytics = () => {
	const { user } = useUser()

	useEffect(() => {
		if (Capacitor.isNativePlatform()) return
		initializeFirebaseWebAnalytics()
	}, [])

	const initializeAnalytics = async (currentUser: User) => {
		await setAnalyticsEnabled(true)
		await setUserId(currentUser.id)

		if (currentUser.language) {
			// Safety check, so Firebase doesnt throw
			await setUserProperty('language', currentUser.language)
		}

		if (currentUser.selectedContract) {
			// Safety check, so Firebase doesnt throw
			await setUserProperty('contractNumber', currentUser.selectedContract)
		}
	}

	useEffect(() => {
		try {
			if (!user || !user?.id) return
			initializeAnalytics(user)
		} catch (error) {
			console.error('Failed to initialize analytics', error)
		}
	}, [user?.id, user?.language, user?.selectedContract])
}

export default useAnalytics
